"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ChangeDirectDebitDateConfirmUI = void 0;
var date_fns_1 = require("date-fns");
var react_1 = __importDefault(require("react"));
var core_1 = require("../../../../../shared/core");
var copy_1 = require("../../../copy");
var ChangeDirectDebitDateConfirmUI = function (_a) {
    var nextPaymentDate = _a.nextPaymentDate, oneTimePaymentPrompt = _a.oneTimePaymentPrompt, amount = _a.amount;
    var _b = (0, core_1.useCopy)(copy_1.defaultOptions), copy = _b.copy, Copy = _b.Copy;
    var cardPayment = (0, core_1.useLinks)().cardPayment;
    var _c = (0, core_1.useComponents)(), Card = _c.Card, Heading1 = _c.Heading1, Stack = _c.Stack, Callout = _c.Callout, PrimaryCTALink = _c.PrimaryCTALink, InternalLink = _c.InternalLink;
    return (react_1.default.createElement(Card, { "data-testid": "ddconfirm-success" },
        react_1.default.createElement(Stack, { spaceBetween: [4, 6] },
            react_1.default.createElement("div", null,
                react_1.default.createElement(Heading1, null, copy('updateDirectDebitDateConfirmationHeading')),
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateConfirmationBody", values: {
                        dayOfMonth: (0, date_fns_1.format)(nextPaymentDate, 'do'),
                        nextPaymentDate: (0, date_fns_1.format)(nextPaymentDate, 'do MMMM yyyy'),
                        amount: (0, core_1.major2DP)((0, core_1.majorToMinor)(amount)),
                    } }),
                oneTimePaymentPrompt ? (react_1.default.createElement(Stack, { spaceBetween: [2, 3] },
                    react_1.default.createElement(Callout, null,
                        react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateConfirmationPaymentPrompt", values: {
                                paymentAmount: (0, core_1.major2DP)((0, core_1.majorToMinor)(amount)),
                            } })),
                    react_1.default.createElement(PrimaryCTALink, { as: InternalLink, href: cardPayment() },
                        react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateConfirmationPaymentCTA" })))) : null,
                react_1.default.createElement(Copy, { copyKey: "updateDirectDebitDateConfirmationLink" })),
            react_1.default.createElement(core_1.FeedbackPrompt, { id: "directDebitDate", probability: 50, label: copy('updateDirectDebitDateFeedbackPrompt') }))));
};
exports.ChangeDirectDebitDateConfirmUI = ChangeDirectDebitDateConfirmUI;
